const getFileExtension = (fileName = "") =>
  fileName.split(".").length > 1 ? fileName.split(".").pop() : "";

export default getFileExtension;
